import { Link } from "@inertiajs/react";
import { Vote, Coins, BarChart3, Plus } from "lucide-react";
import { NavLink } from "./NavLink";

interface MobileMenuProps {
  isActive: (path: string) => boolean;
}

export function MobileMenu({ isActive }: MobileMenuProps) {
  return (
    <div className="fixed bottom-0 inset-x-0 z-30 flex items-center justify-center gap-1 border-t border-border bg-background/90 py-2 backdrop-blur md:hidden">
      <NavLink href="/votes" active={isActive("/votes")} mobile>
        <Vote size={18} />
        Votar
      </NavLink>
      <NavLink href="/submissions" active={isActive("/submissions")} mobile>
        <BarChart3 size={18} />
        Avaliações
      </NavLink>
      <Link
        href="/submissions/new"
        className="flex h-10 w-10 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg"
      >
        <Plus size={20} />
      </Link>
      <NavLink href="/paid_credits" active={isActive("/paid_credits")} mobile>
        <Coins size={18} />
        Créditos
      </NavLink>
    </div>
  );
}
